import React, { useState, useEffect } from "react";
import './AnaliseView.css';

const ESTAGIOS = {
  1: { nome: "Recebida", cor: "#757575" },
  2: { nome: "Em análise", cor: "#1976d2" },
  3: { nome: "Analista", cor: "#0288d1" },
  4: { nome: "Médico", cor: "#8e24aa" },
  5: { nome: "Retornou Benef.", cor: "#fbc02d" },
  6: { nome: "Aprovada", cor: "#43a047" },
  7: { nome: "Recusada", cor: "#e53935" },
  8: { nome: "Concluída", cor: "#388e3c" }
};
function ModalObservacao({ id, onClose, onSave }) {
  const [obs, setObs] = useState("");

  

  const handleSave = () => {
    if (!obs.trim()) {
      alert("Por favor, digite uma observação.");
      return;
    }

    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario/status`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        status: "observacao",
        motivo: obs,
        usuario_nome: localStorage.getItem("nome_usuario") || "",
        usuario_cpf: localStorage.getItem("cpf_usuario") || ""
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
  alert("Observação salva com sucesso!");

  // Monta o objeto da nova observação
  const novaObs = {
    observacao: obs,
    usuario_nome: localStorage.getItem("nome_usuario") || "",
    data_alteracao: new Date().toISOString()
  };

  onSave(novaObs); // envia para o componente pai
}

    })
    .catch(() => alert("Erro ao salvar a observação."));
  };

  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ minWidth: 340, maxWidth: 400 }}>
        <h3>Adicionar Observação</h3>
        <textarea
          value={obs}
          onChange={e => setObs(e.target.value)}
          placeholder="Digite sua observação..."
          style={{
            width: "100%",
            minHeight: 80,
            borderRadius: 8,
            border: "1px solid #bbb",
            marginBottom: 14,
            padding: 10
          }}
        />
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button className="analise-btn" onClick={handleSave} disabled={!obs.trim()}>
            Salvar
          </button>
          <button className="analise-btn-sec" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}


// Modal de análise completa (detalhado)
function AnaliseModalCompleta({ id, onClose, onEncaminharMedico, onReload }) {
  const [detalhe, setDetalhe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQuestionario, setShowQuestionario] = useState(false);
  const [showAnexos, setShowAnexos] = useState(false);
  const [anexosFamilia, setAnexosFamilia] = useState([]);
  const [reload, setReload] = useState(0);
  const [reloadInterno, setReloadInterno] = useState(0);
  const [statusQuestionario, setStatusQuestionario] = useState(null);
  const [obsQuestionario, setObsQuestionario] = useState(null);
  const [dependentes, setDependentes] = useState([]);
  const estagioAprovado = detalhe && detalhe.Estagio === 6 && dependentes.every(dep => dep.Estagio === 6);
  const [showModalCriticos, setShowModalCriticos] = useState(false);
  const [criticosSelecionados, setCriticosSelecionados] = useState([]);
  const [showObsModal, setShowObsModal] = useState(false);
  const [advertencias, setAdvertencias] = useState([]);
const [showAdvertencias, setShowAdvertencias] = useState(false);
const [carregandoDevolucao, setCarregandoDevolucao] = useState(false);
const [showModalObs, setShowModalObs] = useState(false);
//const [obsDevolucao, setObsDevolucao] = useState("");
const [carregandoEnvio, setCarregandoEnvio] = useState(false);

  





{carregandoDevolucao && (
  <div className="fullscreen-spinner">
    <div className="spinner-text-container">
      <div className="spinner"></div>
      <div className="spinner-text">Processando...</div>
    </div>
  </div>
)}



  // BOTOES DO ANALISE COMPLETA
  async function encaminharParaMedico(criticos = []) {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  try {
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 4 })
        })
      )
    );
    // Salva o campo crítico (ajuste o endpoint/campo conforme seu backend!)
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/critico`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ critico: criticos.includes(bid) })
        })
      )
    );
    alert("Todos foram encaminhados para o Médico!");
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao encaminhar. Tente novamente.");
  }
}

async function iniciarAnalise(id) {
  const usuarioId = localStorage.getItem("usuario_id");  // ID do usuário logado

  if (!usuarioId) {
    alert("Usuário não está logado.");
    return;
  }

  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/analista`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ analista: usuarioId })  // Envia o ID do usuário logado como analista
    });

    const data = await response.json();
    if (response.ok && data.success) {
      alert("Análise iniciada com sucesso!");
      // Lógica para atualizar a interface ou navegar para outra tela
      if (onReload) {
        onReload(); // Recarregar os dados ou atualizar a interface
      }
    } else {
      alert("Falha ao iniciar análise.");
    }
  } catch (error) {
    console.error("Erro ao enviar dados para o backend:", error);
    alert("Ocorreu um erro ao iniciar a análise.");
  }
}





async function devolverParaBeneficiario(obsTexto) {
  setCarregandoDevolucao(true);
  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${detalhe.id}/devolver`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        observacao: obsTexto, // <-- ENVIA JUNTO
        usuario_nome: localStorage.getItem("nome_usuario") || "",
        usuario_cpf: localStorage.getItem("cpf_usuario") || ""
      })
    });

    const data = await response.json();
    if (response.ok && data.success) {
      alert("Proposta devolvida ao beneficiário e e-mails enviados!");
      if (onReload) onReload();
      if (onClose) onClose();
    } else {
      alert("Erro ao devolver: " + (data.detail || "Erro desconhecido"));
    }
  } catch (err) {
    console.error("Erro ao devolver:", err);
    alert("Falha ao devolver. Verifique a conexão.");
  } finally {
    setCarregandoDevolucao(false);
  }
}






async function voltarParaAnalista() {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  try {
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 3 })
        })
      )
    );
    alert("Proposta(s) reaberta(s) para análise!");
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao reabrir. Tente novamente.");
  }
}

async function cancelarProposta() {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  try {
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 7 })
        })
      )
    );
    alert("Proposta cancelada para todos!");
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao cancelar. Tente novamente.");
  }
}

useEffect(() => {
  if (!id) return;

  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/verificar_regras`)
    .then(r => r.json())
    .then(data => {
      const itens = (data.advertencias || []).map((a) => ({
        nome: "Titular",
        mensagem: a.descricao,
        regra: a.id
      }));
      setAdvertencias(itens);
    })
    .catch(() => setAdvertencias([]));
}, [id, reloadInterno]);

useEffect(() => {
  if (!id) return;
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/observacoes`)
    .then(r => r.json())
    .then(setObsQuestionario)
    .catch(() => setObsQuestionario([]));
}, [id, reloadInterno]);




  useEffect(() => {
  setLoading(true);
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
    .then(r => r.json())
    .then(data => {
      setDetalhe(data);
      setDependentes(data.dependentes || []); // <-- Aqui salva os dependentes no state
    })
    .finally(() => setLoading(false));
  }, [id, reloadInterno]);

  useEffect(() => {
    if (!id) return;
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/anexos`)
      .then(r => r.json())
      .then(setAnexosFamilia)
      .catch(() => setAnexosFamilia([]));
  }, [id, reload]);

  useEffect(() => {
  if (!id) return;
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/status_atual`)
    .then(r => r.json())
    .then(data => setStatusQuestionario(data))
    .catch(() => setStatusQuestionario(null));
}, [id, reloadInterno]);






  const formatData = d => {
    if (!d) return "";
    if (/^\d{8}$/.test(d)) return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
    const dt = new Date(d);
    return isNaN(dt.getTime()) ? "" : dt.toLocaleDateString();
  };

  const calcularIdade = (data) => {
    if (!data) return "";
    let dia, mes, ano;
    if (/^\d{8}$/.test(data)) {
      dia = parseInt(data.slice(0, 2), 10);
      mes = parseInt(data.slice(2, 4), 10) - 1;
      ano = parseInt(data.slice(4, 8), 10);
    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
      const parts = data.split("/");
      dia = parseInt(parts[0], 10);
      mes = parseInt(parts[1], 10) - 1;
      ano = parseInt(parts[2], 10);
    } else return "";
    const nascimento = new Date(ano, mes, dia);
    if (nascimento.getFullYear() !== ano || nascimento.getMonth() !== mes || nascimento.getDate() !== dia) return "";
    const hoje = new Date();
    let idade = hoje.getFullYear() - ano;
    if (hoje.getMonth() < mes || (hoje.getMonth() === mes && hoje.getDate() < dia)) idade--;
    return idade >= 0 ? idade : "";
  };

  if (loading) return <div className="analise-modal-bg"><div className="analise-modal"><div style={{ padding: 24, color: "#888" }}>Carregando detalhes...</div></div></div>;
  if (!detalhe) return <div className="analise-modal-bg"><div className="analise-modal"><div style={{ padding: 24, color: "#e04d4d" }}>Não encontrado.</div></div></div>;

  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ maxWidth: 1500 }}>
        <h2 className="pv-section-title" style={{ marginTop: 0, marginBottom: 14 }}>Análise Completa</h2>
        <div style={{
          display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8, marginBottom: 14, alignItems: "center",
        }}>
          <div><b>Nome:</b> {detalhe.nome}</div>
          <div><b>CPF:</b> {detalhe.cpf}</div>
          <div><b>Data Nasc.:</b> {formatData(detalhe.data_nascimento)}
            {(() => {
              const idade = calcularIdade(detalhe.data_nascimento);
              return idade !== "" ? <span className="pv-tag">{idade} anos</span> : null;
            })()}
          </div>
          <div><b>Nome Mãe:</b> {detalhe.nome_mae}</div>
          <div><b>Email:</b> {detalhe.email}</div>
          <div><b>Celular:</b> {detalhe.celular}</div>
          <div><b>Telefone:</b> {detalhe.telefone}</div>
          <div><b>CEP:</b> {detalhe.cep}</div>
          <div style={{ gridColumn: "span 4" }}>
            <b>Endereço:</b> {detalhe.rua}, {detalhe.numero}, {detalhe.complemento}
          </div>
          <div><b>Bairro:</b> {detalhe.bairro}</div>
          <div><b>Cidade:</b> {detalhe.cidade}/{detalhe.estado}</div>
          <div><b>Vendedor:</b> {detalhe.vendedor}</div>
          <div><b>Corretora:</b> {detalhe.corretora}</div>
          <div><b>Analista:</b> {detalhe.analista_nome || detalhe.analista}</div>
          <div><b>Médico:</b> {detalhe.medico_nome || detalhe.medico}</div>
          <div><b>Estágio:</b> {detalhe.estagio_nome || detalhe.Estagio}</div>
          <div><b>Portabilidade:</b> {detalhe.Portabilidade}</div>
          <div><b>Plano:</b> {detalhe.nome_plano || detalhe.produto_id}</div>
          <div>
            <b>Sexo:</b>{" "}
            {["M", "m", "H", "h"].includes((detalhe.sexo || "").toUpperCase())
              ? "Homem"
              : ["F", "f", "Mulher"].includes((detalhe.sexo || "").toUpperCase())
                ? "Mulher"
                : detalhe.sexo_descricao || detalhe.sexo || "-"}
          </div>
          <div><b>Peso:</b> {detalhe.peso} kg</div>
          <div><b>Altura:</b> {detalhe.altura} cm</div>
          <div><b>IMC:</b>{" "}
            {detalhe.peso && detalhe.altura
              ? (detalhe.peso / Math.pow(detalhe.altura / 100, 2)).toFixed(2)
              : ""}
          </div>
        </div>
                {/* STATUS DO QUESTIONÁRIO - COLE ESTE BLOCO */}
        <div style={{ margin: "8px 0 16px 0", fontWeight: 500 }}>
          <span>Questionário: </span>
          {statusQuestionario?.status === "aprovado" && (
            <>
              <span style={{ color: "#43a047" }}>Aprovado</span>
              {statusQuestionario.usuario_nome && (
                <span> — Por <b>{statusQuestionario.usuario_nome}</b></span>
              )}
              {statusQuestionario.data_alteracao && (
              <span>
                {" "}Em <b>{formatData(statusQuestionario.data_alteracao)}</b>
              </span>
            )}
            </>
          )}
          {statusQuestionario?.status === "reprovado" && (
            <>
              <span style={{ color: "#e53935" }}>Reprovado</span>
              {statusQuestionario.usuario_nome && (
                <span> — Por <b>{statusQuestionario.usuario_nome}</b></span>
              )}
              {statusQuestionario.data_alteracao && (
              <span>
                {" "}Em <b>{formatData(statusQuestionario.data_alteracao)}</b>
              </span>
            )}
            </>
          )}
          {!statusQuestionario?.status && (
            <span style={{ color: "#888" }}>Em análise</span>
          )}
          {obsQuestionario && obsQuestionario.length > 0 && (
          <div style={{
              background: "#fffbe7",
              border: "1px solid #ffe082",
              borderRadius: 8,
              padding: "8px 14px",
              marginBottom: 12,
              marginTop: 4,
              fontSize: 15
          }}>
            <b>Histórico de Observações:</b>
            <ul style={{ margin: "8px 0 0 0", padding: 0, listStyle: "none" }}>
              {obsQuestionario.map((obs, idx) => (
                <li key={idx} style={{ marginBottom: 8 }}>
                  <span style={{ color: "#888" }}>
                    {obs.usuario_nome && <b>{obs.usuario_nome}</b>}
                   {obs.data_alteracao && (  <> — {obs.data_alteracao} </>)}

                  </span>
                  <span style={{ color: "#333", marginLeft: 10 }}>
                    — {obs.observacao}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        </div>                                        

        {/* FIM DO BLOCO STATUS DO QUESTIONÁRIO */}
        <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
          


          {detalhe.questionario_id ? (
            <button className="analise-btn" onClick={() => setShowQuestionario(true)}>Ver Questionário Saúde</button>
          ) : (
            <span style={{ color: "#f9a825", fontWeight: 600, fontSize: 13, marginLeft: 8 }}>Sem questionário</span>
          )}
          {anexosFamilia.length > 0 && (
            <button className="analise-btn-sec" onClick={() => setShowAnexos(true)}>Anexos</button>
          )}
          <button
            className="analise-btn-sec"
            onClick={() => setShowObsModal(true)} // Abre o modal de observação
            style={{
              background: "#fffbe7",
              border: "1.5px solid #fbc02d",
              color: "#000000ff",
              fontWeight: 600
            }}
          >
            Adicionar Observação
          </button>
            <button
                className="analise-btn-sec"
                onClick={() => advertencias.length > 0 && setShowAdvertencias(prev => !prev)}
                disabled={advertencias.length === 0}
                style={{
                  background: advertencias.length > 0 ? "#fff3cd" : "#eee",
                  border: "1.5px solid " + (advertencias.length > 0 ? "#ffb300" : "#ccc"),
                  color: advertencias.length > 0 ? "#000" : "#888",
                  fontWeight: 700,
                  cursor: advertencias.length > 0 ? "pointer" : "not-allowed"
                }}
              >
                Advertência
              </button>
              
            </div>
            {showAdvertencias && (
                  <div style={{
                    background: "#fffde7",
                    border: "1px solid #ffeb3b",
                    borderRadius: 8,
                    padding: "10px 16px",
                    marginTop: 16
                  }}>
                    <b>Advertências detectadas:</b>
                    <ul style={{ marginTop: 8 }}>
                      {advertencias.map((a, idx) => (
                        <li key={idx} style={{ marginBottom: 6 }}>
                          <span style={{ fontWeight: 500 }}>{a.nome}:</span>{" "}
                          <span style={{ color: "#d84315" }}>{a.mensagem}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 32 }}>
          <button className="analise-btn-sec" onClick={onClose}>Fechar</button>
        </div>
           {showObsModal && (
  <ModalObservacao
    id={id}
    onClose={() => setShowObsModal(false)} // Fecha o modal diretamente
    onSave={(novaObs) => {
      setShowObsModal(false);
      setObsQuestionario(prev => [novaObs, ...prev]); // Insere no topo
    }}
  />
)}
        {/* Bloco de Ações Destacado */}
        {(!detalhe.id_titular) && (
        <div
          style={{
            background: "#f5f5f5",
            borderRadius: 12,
            padding: "18px 20px",
            margin: "34px 0 10px 0",
            boxShadow: "0 1px 4px #0001",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
          }}
        >
          <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 12 }}>Ações disponíveis</div>
          <div style={{ display: "flex", gap: 12 }}>
           <button
            className="analise-btn"
            onClick={() => setShowModalCriticos(true)}
            disabled={estagioAprovado}
          >
            Encaminhar para Médico
          </button>
          <button
          className="analise-btn-sec"
          onClick={() => setShowModalObs(true)}
        >
          Devolver ao Beneficiário
        </button>
     
          </div>
        </div>
      )}

            {showModalCriticos && (
        <div className="analise-modal-bg">
          <div className="analise-modal" style={{ maxWidth: 500 }}>
            <h3>Selecionar casos críticos</h3>
            <div style={{ margin: "16px 0" }}>
              {[
                { ...detalhe, nome: detalhe.nome + " (Titular)", tipo: "titular" },
                ...dependentes.map(d => ({ ...d, tipo: "dependente" }))
              ].map(b => (
                <div key={b.id} style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10,
                  background: criticosSelecionados.includes(b.id) ? "#ffebee" : "transparent",
                  borderRadius: 8,
                  padding: 6
                }}>
                  <input
                    type="checkbox"
                    checked={criticosSelecionados.includes(b.id)}
                    onChange={() => {
                      setCriticosSelecionados(sel =>
                        sel.includes(b.id)
                          ? sel.filter(id => id !== b.id)
                          : [...sel, b.id]
                      );
                    }}
                    id={`critico-${b.id}`}
                  />
                  <label htmlFor={`critico-${b.id}`} style={{ marginLeft: 8, fontWeight: 500 }}>
                    {b.nome} — {b.cpf}
                  </label>
                  {criticosSelecionados.includes(b.id) && (
                    <span style={{ color: "#b71c1c", marginLeft: 10 }}>CRÍTICO</span>
                  )}
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                className="analise-btn"
                onClick={async () => {
                  await encaminharParaMedico(criticosSelecionados);
                  setShowModalCriticos(false);
                  setCriticosSelecionados([]);
                }}
              >
                Confirmar Encaminhamento
              </button>
              <button
                className="analise-btn-sec"
                onClick={() => setShowModalCriticos(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}



        {showQuestionario && (
            <ModalQuestionario
              id={id}
              onClose={() => {
                setShowQuestionario(false);
                setReloadInterno(x => x + 1); // << recarrega detalhes sem fechar Analise Completa
                if (onReload) onReload(); // opcional: recarrega lista pai também
              }}
              onEncaminharMedico={() => {
                if (onClose) onClose();
                if (onEncaminharMedico) onEncaminharMedico();
                if (onReload) onReload();  // <-- Adiciona aqui também, se quiser recarregar quando encaminha!
              }}
            />
          )}
          {showAnexos && (
            <ModalAnexos anexos={anexosFamilia} onClose={() => setShowAnexos(false)} />
          )}

          {showModalObs && (
          <ModalObservacao
            id={id}
            onClose={() => setShowModalObs(false)}
            onSave={(novaObs) => {
              setShowModalObs(false);
              setCarregandoEnvio(true); // escurece a tela

              setObsQuestionario(prev => [
                {
                  texto: novaObs.observacao,
                  data: new Date().toISOString(),
                },
                ...prev
              ]);

              devolverParaBeneficiario(novaObs.observacao)
                .finally(() => {
                  setCarregandoEnvio(false); // volta ao normal
                });
            }}

          />
        )}
      {carregandoEnvio && (
        <div className="overlay-loading">
          <div className="spinner" />
          <p>Devolvendo para o Beneficiário...</p>
        </div>
      )}
      </div>
    </div>
  );
}

// Modal Questionário Saúde com edição in-line
function ModalQuestionario({ id, onClose, onEncaminharMedico }) {
  const [quest, setQuest] = useState([]);
  const [beneficiario, setBeneficiario] = useState(null);
  const nomeUsuario = localStorage.getItem("nome_usuario") || "";
  const cpfUsuario = localStorage.getItem("cpf_usuario") || "";
  const [editandoId, setEditandoId] = useState(null);
  const [respostaEditada, setRespostaEditada] = useState("");
  const [motivo, setMotivo] = useState("");
  const [showMotivoModal, setShowMotivoModal] = useState(false);
  const [acao, setAcao] = useState("");
  const [statusAtual, setStatusAtual] = useState(null);
  const [obsAtual, setObsAtual] = useState(null);
  const usuarioId = localStorage.getItem("usuario_id");
  const estagioAprovado = beneficiario && beneficiario.Estagio === 6;
  const [obsQuestionario, setObsQuestionario] = useState([]);
  const [reloadInterno, setReloadInterno] = useState(0);



  useEffect(() => {
  carregarStatusAtual();
  }, [id]);

  useEffect(() => {
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario`)
      .then(r => r.json())
      .then(setQuest)
      .catch(() => setQuest([]));
  }, [id]);

  useEffect(() => {
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
      .then(r => r.json())
      .then(setBeneficiario)
      .catch(() => setBeneficiario(null));
  }, [id]);

    useEffect(() => {
      if (!id) return;
      fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/observacoes`)
        .then(r => r.json())
        .then(setObsQuestionario) // Atualiza o estado com o histórico de observações
        .catch(() => setObsQuestionario([])); // Em caso de erro, define como um array vazio
    }, [id, reloadInterno]); // O efeito será executado sempre que o `id` mudar


  function handleEditar(q) {
    setEditandoId(q.pergunta_id);
    setRespostaEditada(q.resposta);
  }
  function handleCancelarEdicao() {
    setEditandoId(null);
    setRespostaEditada("");
  }

  function carregarStatusAtual() {
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/status_atual`)
    .then(r => r.json())
    .then(d => setStatusAtual(d)) // d é { status, usuario_nome, data_alteracao }
    .catch(() => setStatusAtual(null));
  }



  function handleSalvarResposta(perguntaId) {
    const motivoPrompt = prompt("Motivo da alteração desta resposta (para auditoria):");
    if (!motivoPrompt) return;
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        pergunta_id: perguntaId,
        resposta: respostaEditada,
        motivo: motivoPrompt,
        usuario_nome: nomeUsuario, // <- pego do localStorage no topo do componente!
        usuario_cpf: cpfUsuario
      })
    })
      .then(r => r.json())
      .then(() => {
        setQuest(qs =>
          qs.map(q =>
            q.pergunta_id === perguntaId
              ? { ...q, resposta: respostaEditada }
              : q
          )
        );
        setEditandoId(null);
        setRespostaEditada("");
        alert("Alteração salva com sucesso!");
      });
  }

function handleMotivoConfirm() {
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario/status`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      status: acao,
      motivo,
      usuario_nome: nomeUsuario,
      usuario_cpf: cpfUsuario,
      usuario_id: usuarioId
    })
  })
    .then(r => r.json())
    .then(() => {
      setShowMotivoModal(false);
      setMotivo("");
      setAcao("");
      alert("Status atualizado com sucesso!");
      carregarStatusAtual();

      // Atualiza as observações automaticamente após a alteração
      setReloadInterno(prev => prev + 1); // Atualiza o estado para disparar o useEffect de observações

      if (acao === "Encaminhar_medico" && onEncaminharMedico) {
        onEncaminharMedico();
      }
    })
    .catch(err => {
      console.error("Erro ao salvar o status: ", err);
    });
}



  function handleMotivoCancel() {
    setShowMotivoModal(false);
    setMotivo("");
    setAcao("");
  }

  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ maxWidth: 600 }}>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button className="analise-btn-sec" onClick={onClose}>
            Fechar
          </button>
        </div>
        <h3 style={{ marginTop: 8 }}>Questionário de Saúde</h3>
        <div style={{ marginBottom: 18, fontSize: 16 }}>
          <b>Nome:</b> {beneficiario?.nome || "-"}
          <br />
          <b>CPF:</b> {beneficiario?.cpf || "-"}
          <br />
          <b>Plano:</b> {beneficiario?.nome_plano || beneficiario?.produto_id || "-"}
        </div>
         <div style={{ marginBottom: 12 }}>
          <b>Situação: </b>
          {statusAtual?.status === "aprovado" ? (
            <>
              <span style={{ color: "#43a047", fontWeight: 600 }}>Aprovado</span>
              {statusAtual.usuario_nome && (
                <span style={{ marginLeft: 12 }}>
                  por <b>{statusAtual.usuario_nome}</b>
                </span>
              )}
              {statusAtual.data_alteracao && (
                <span style={{ marginLeft: 12 }}>
                  Data: <b>{new Date(statusAtual.data_alteracao).toLocaleString()}</b>
                </span>
              )}
            </>
          ) : statusAtual?.status === "reprovado" ? (
            <>
              <span style={{ color: "#e53935", fontWeight: 600 }}>Reprovado</span>
              {statusAtual.usuario_nome && (
                <span style={{ marginLeft: 12 }}>
                  por <b>{statusAtual.usuario_nome}</b>
                </span>
              )}
              {statusAtual.data_alteracao && (
                <span style={{ marginLeft: 12 }}>
                  Data: <b>{new Date(statusAtual.data_alteracao).toLocaleString()}</b>
                </span>
              )}
            </>
          ) : (
            <span style={{ color: "#888", fontWeight: 600 }}>Em análise</span>
          )}
        </div>
          {obsAtual && obsAtual.observacao && (
            <div style={{
              background: "#fffbe7",
              border: "1px solid #ffe082",
              borderRadius: 8,
              padding: "8px 14px",
              marginBottom: 12,
              marginTop: 4
            }}>
              <b>Observação:</b>{" "}
              {obsAtual && obsAtual.observacao ? (
                <>
                  <span style={{ color: "#888" }}>
                    {obsAtual.usuario_nome && <b>{obsAtual.usuario_nome}</b>}
                    {obsAtual.data_alteracao && (
                      <> — {new Date(obsAtual.data_alteracao).toLocaleString()} </>
                    )}
                  </span>
                  <span style={{ color: "#333", marginLeft: 10 }}>
                    — {obsAtual.observacao}
                  </span>
                </>
              ) : (
                <span style={{ color: "#aaa" }}>Sem observação</span>
              )}


            </div>
          )}





        {beneficiario?.obs_questionario && (
          <div style={{
            background: "#fffbe7",
            border: "1px solid #ffe082",
            borderRadius: 8,
            padding: "8px 14px",
            marginBottom: 16
          }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Observação</div>
            <div style={{ color: "#555" }}>{beneficiario.obs_questionario}</div>
          </div>
        )}
        {quest.length === 0 ? (
          <div style={{ color: "#888", textAlign: "center" }}>
            Nenhuma resposta encontrada.
          </div>
        ) : (
          <table
            style={{
              width: "100%",
              background: "#f9fafd",
              borderRadius: 8,
              fontSize: 16,
            }}
          >
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "8px" }}>Pergunta</th>
                <th style={{ textAlign: "left", padding: "8px" }}>Resposta</th>
              </tr>
            </thead>
            <tbody>
              {quest.map(q => (
                <tr key={q.pergunta_id}>
                  <td style={{ padding: "8px 8px 8px 0" }}>{q.pergunta}</td>
                  <td style={{ padding: "8px", position: "relative" }}>
                    {editandoId === q.pergunta_id ? (
                      <>
                        <input
                          value={respostaEditada}
                          onChange={e => setRespostaEditada(e.target.value)}
                          style={{ width: "70%" }}
                        />
                        <button
                          className="analise-btn-aprovar"
                          style={{ marginLeft: 8 }}
                          onClick={() => handleSalvarResposta(q.pergunta_id)}
                          title="Salvar"
                        >✔️</button>
                        <button
                          className="analise-btn-reprovar"
                          style={{ marginLeft: 4 }}
                          onClick={handleCancelarEdicao}
                          title="Cancelar"
                        >✖️</button>
                      </>
                    ) : (
                      <>
                        {q.resposta}
                        <button
                          style={{
                            marginLeft: 8,
                            background: "none",
                            border: "none",
                            cursor: "pointer"
                          }}
                          title="Editar resposta"
                          onClick={() => handleEditar(q)}
                          disabled={estagioAprovado}
                        >✏️</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Botões de ação */}
        <div style={{ display: "flex", gap: 12, marginTop: 28 }}>
          <button
            className="analise-btn-aprovar"
            onClick={() => {
              setAcao("aprovado"); // <-- CORRETO!
              setShowMotivoModal(true);
            }}
          >
            Aprovar
          </button>
          <button
            className="analise-btn-reprovar"
            onClick={() => {
              setAcao("reprovado");
              setShowMotivoModal(true);
            }} disabled={estagioAprovado}
          >
            Reprovar
          </button>
          <button
            className="analise-btn-sec"
            onClick={() => {
              setAcao("Observacao");
              setShowMotivoModal(true);
            }} disabled={estagioAprovado}
          >
            Observação
          </button>
          
        </div>

        {showMotivoModal && (
          <div className="analise-modal-bg">
            <div
              className="analise-modal"
              style={{
                minWidth: 350,
                maxWidth: 400,
                margin: "auto",
                padding: 24,
                textAlign: "center",
              }}
            >
              <div style={{ marginBottom: 12, fontWeight: 600 }}>
                {acao === "aprovar" && "Aprovação do Questionário"}
                {acao === "reprovar" && "Reprovação do Questionário"}
                {acao === "observacao" && "Adicionar Observação"}
                {acao === "encaminhar_medico" && "Encaminhar para Médico"}
              </div>
              <textarea
                style={{
                  width: "100%",
                  minHeight: 60,
                  borderRadius: 8,
                  border: "1px solid #bbb",
                  marginBottom: 16,
                  padding: 8,
                }}
                value={motivo}
                onChange={e => setMotivo(e.target.value)}
                placeholder="Descreva o motivo ou observação"
              />
              <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
                <button
                  className="analise-btn"
                  onClick={handleMotivoConfirm}
                  disabled={!motivo.trim()}
                >
                  Confirmar
                </button>
                <button className="analise-btn-sec" onClick={handleMotivoCancel}>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// Modal Anexos (igual PropostasView)
function ModalAnexos({ anexos = [], onClose }) {
  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ minWidth: 400, maxWidth: 700 }}>
        <h3 className="pv-section-title" style={{ marginTop: 0 }}>Anexos</h3>
        {anexos.length === 0 ? (
          <div style={{ color: "#888", marginBottom: 12 }}>Nenhum anexo encontrado.</div>
        ) : (
          <ul style={{ margin: "4px 0 0 18px", padding: 0 }}>
            {anexos.map(ax => (
              <li key={ax.caminho} style={{ marginBottom: 2, listStyle: "disc" }}>
                <a
                  href={`https://gerencial.vionia.com.br/api/anexos/${ax.caminho}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {ax.nome}
                </a>
              </li>
            ))}
          </ul>
        )}
        <button className="analise-btn" onClick={onClose} style={{ marginTop: 16 }}>Fechar</button>
      </div>
    </div>
  );
}

export default function AnaliseView() {
  const [propostas, setPropostas] = useState([]);
  const [selecionada, setSelecionada] = useState(null);
  const [modalPacienteId, setModalPacienteId] = useState(null);
  const [reload, setReload] = useState(0);
  const [isAnaliseAssumida, setIsAnaliseAssumida] = useState(false);
  const [analisesAssumidas, setAnalisesAssumidas] = useState({});
  const [statusBeneficiario, setStatusBeneficiario] = useState({});
  const [detalhe, setDetalhe] = useState(null);
  const [dependentes, setDependentes] = useState([]);

const conferirBeneficiario = async (id) => {
  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/critico`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ critico: 2 })  // 2 = conferido
    });

    const data = await response.json();
    if (response.ok && data.success) {
      alert("Beneficiário conferido e aprovado!");

      // Atualiza o status visual imediatamente
      setPropostas(prev =>
        prev.map(b =>
          b.id === id ? { ...b, critico_medico: 2 } : b
        )
      );

      // Também mantém o status local de conferência
      setStatusBeneficiario(prevState => ({
        ...prevState,
        [id]: 2
      }));
    } else {
      alert("Falha ao conferir o beneficiário.");
    }
  } catch (error) {
    console.error("Erro ao enviar dados para o backend:", error);
    alert("Ocorreu um erro ao conferir o beneficiário.");
  }
};





  // Função assumirAnálise dentro de AnaliseView
const assumirAnalise = async (id) => {
  const usuarioId = localStorage.getItem("usuario_id");

  if (!usuarioId) {
    alert("Usuário não está logado.");
    return;
  }

  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/analista`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ analista: usuarioId }),
    });

    const data = await response.json();

    if (response.ok && data.success) {
      alert("Análise assumida com sucesso!");
      setAnalisesAssumidas(prevState => ({
        ...prevState,
        [id]: true  // Marcar este beneficiário como assumido
      }));
      setReload(prevReload => prevReload + 1); // Atualize o estado
    } else {
      alert("Falha ao assumir análise.");
    }
  } catch (error) {
    console.error("Erro ao enviar dados para o backend:", error);
    alert("Ocorreu um erro ao assumir a análise.");
  }
};





  function getCodigoProposta(p, allPropostas) {
    if (!p) return "-";
    if (p.id_proposta) return p.id_proposta;
    if (p.tipo === "titular") {
      const dependente = allPropostas.find(
        x => x.tipo === "dependente" && x.id_titular === p.id && x.id_proposta
      );
      return dependente?.id_proposta || "-";
    }
    return "-";
  }

  


useEffect(() => {
  // Definindo os parâmetros de consulta corretamente
  const params = new URLSearchParams({
    page: 1,
    per_page: 10,
    estagio: 3,
  });

  fetch(`https://gerencial.vionia.com.br/api/beneficiarios?${params}`)
    .then((res) => res.ok ? res.json() : [])
    .then((data) => {
      const agrupados = [];

      // Mapeando os dados para incluir os dependentes
      data.forEach(titular => {
        agrupados.push({ ...titular, tipo: "titular" });
        if (titular.dependentes && Array.isArray(titular.dependentes)) {
          titular.dependentes.forEach(dep => {
            agrupados.push({ ...dep, tipo: "dependente", id_titular: titular.id });
          });
        }
      });

      // Agora vamos buscar o status_questionario para cada beneficiário
      const fetchStatuses = agrupados.map(async (beneficiario) => {
        try {
          const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${beneficiario.id}/status_atual`);
          const statusData = await response.json();
          // Adicionando o status ao beneficiário
          return { ...beneficiario, status_questionario: statusData.status };
        } catch (error) {
          console.error("Erro ao buscar status_questionario", error);
          return { ...beneficiario, status_questionario: null };
        }
      });

      // Espera todos os status serem carregados
      Promise.all(fetchStatuses)
        .then((propostasComStatus) => {
          setPropostas(propostasComStatus); // Atualiza o estado com as propostas e status
        });

    })
    .catch(() => setPropostas([]));
}, [reload]);

async function aprovarProposta(id) {
  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/status_proposta`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status_proposta: 1 }) // ou outro valor adequado ao seu fluxo
    });

    const data = await response.json();
    if (response.ok && data.success) {
      alert("Proposta(s) da família aprovada(s) com sucesso!");
      setReload(prev => prev + 1);
    } else {
      alert("Falha ao aprovar: " + (data.detail || "Erro desconhecido"));
    }
  } catch (err) {
    alert("Erro ao aprovar a proposta.");
    console.error(err);
  }
}

async function cancelarProposta(id) {
  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/estagio`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ estagio: 7 })
    });

    const data = await response.json();
    if (response.ok && data.success) {
      alert("Proposta cancelada com sucesso!");
      setReload(prev => prev + 1);
    } else {
      alert("Falha ao cancelar: " + (data.detail || "Erro desconhecido"));
    }
  } catch (err) {
    alert("Erro ao cancelar a proposta.");
    console.error(err);
  }
}



  function familiaTodaConferida(p) {
  if (p.tipo !== "titular") return false;

  const membros = [p, ...propostas.filter(d => d.tipo === "dependente" && d.id_titular === p.id)];
  return membros.every(m => m.critico_medico === 2);
}


  function getDependentes(titularId) {
    return propostas.filter(p => p.tipo === "dependente" && p.id_titular === titularId);
  }

  function getTitularDependente(dep) {
    return propostas.find(p => p.tipo === "titular" && p.id === dep.id_titular);
  }

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>Análise Técnica</h2>
      {propostas.length === 0 ? (
        <p style={{ color: "#888" }}>Nenhuma proposta pendente.</p>
      ) : (
        <table className="analise-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Código Proposta</th>
              <th>Nome</th>
              <th>CPF</th>
              <th>Plano</th>
              <th>Data</th>
              <th>Corretora</th>
              <th>Vendedor</th>
              <th>Estágio</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {propostas.map((p) => (
              <React.Fragment key={`${p.tipo}-${p.id}`}>
                <tr 
                                    className={
                  (p.tipo === "dependente" ? "analise-dependente " : "") + 
                  (p.critico_medico === 1 ? " analise-critico" : "")+ 
                  (p.critico_medico === 2 ? " analise-aprovado" : "")
                  
                }
                  >
                  <td>{p.id}</td>
                  <td>{getCodigoProposta(p, propostas)}</td>
                  <td>
                    {p.tipo === "dependente" ? (
                      <span style={{ marginLeft: 8 }}>↳ {p.nome} <small style={{ color: "#888" }}>(Dependente)</small></span>
                    ) : (
                      <strong>{p.nome}</strong>
                    )}
                  </td>
                  <td>{p.cpf}</td>
                  <td>{p.nome_plano || p.produto_id || "-"}</td>
                  <td>{p.data_inicio ? new Date(p.data_inicio).toLocaleDateString() : ""}</td>
                  <td>{p.corretora || "-"}</td>
                  <td>{p.vendedor || "-"}</td>
                  <td>
                    {ESTAGIOS[p.Estagio] ? (
                      <span
                        className="analise-badge-estagio"
                        style={{ background: ESTAGIOS[p.Estagio].cor }}
                      >
                        {ESTAGIOS[p.Estagio].nome}
                      </span>
                    ) : "-"}
                  </td>
                  <td>
                    <button
                      className="analise-btn"
                      onClick={() =>
                        setSelecionada(selecionada?.id === p.id && selecionada?.tipo === p.tipo ? null : p)
                      }
                    >
                      Ver Resumo
                    </button>
                  </td>
                </tr>
                {selecionada?.id === p.id && selecionada?.tipo === p.tipo && (
                  <tr>
                    <td colSpan={10}>
                      <div className="analise-resumo" style={{ marginTop: 0 }}>
                        <h3 style={{ marginTop: 0 }}>Resumo da Proposta #{p.id_proposta}</h3>
                        <div className="analise-grid">
                          <div><div className="analise-label">Nome</div>{p.nome}</div>
                          <div><div className="analise-label">CPF</div>{p.cpf}</div>
                          <div><div className="analise-label">Plano</div>{p.nome_plano || p.produto_id || "-"}</div>
                          <div><div className="analise-label">Data Início</div>{p.data_inicio ? new Date(p.data_inicio).toLocaleDateString() : ""}</div>
                          <div><div className="analise-label">Corretora</div>{p.corretora || "-"}</div>
                          <div><div className="analise-label">Vendedor</div>{p.vendedor || "-"}</div>
                          <div><div className="analise-label">Analista</div>{p.analista_nome || p.analista || "-"}</div>
                          <div><div className="analise-label">Médico</div>{p.medico_nome || p.medico || "-"}</div>
                          <div>
                            <div className="analise-label">Código Proposta</div>
                            {getCodigoProposta(p, propostas)}
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
                         <button
                          className="analise-btn-sec"
                          onClick={() => {
                            console.log(`Assumindo análise para o id: ${p.id}`);  // Log para verificação
                            assumirAnalise(p.id);
                          }}
                        >
                          Assumir Análise
                        </button>
                        <button
                            className="analise-btn"
                            onClick={() => setModalPacienteId(p.id)}  // Abre o modal para iniciar análise
                            disabled={!analisesAssumidas[p.id]}  // Desabilita se a análise não foi assumida para esse ID específico
                            style={{
                              backgroundColor: analisesAssumidas[p.id] ? '#0288d1' : '#b0bec5',  // Cor mais suave quando desabilitado
                              cursor: analisesAssumidas[p.id] ? 'pointer' : 'not-allowed',
                            }}
                          >
                            Iniciar Análise
                          </button>

                          <button
                            className="analise-btn-sec"
                            onClick={() => setSelecionada(null)}
                          >
                            Fechar
                          </button>
                          <button
                          className="analise-btn-sec"
                          onClick={() => conferirBeneficiario(p.id)}   // Chama a função para marcar como aprovado
                          style={{
                            background: "#43a047", // Cor de aprovado
                            color: "#fff",
                            fontWeight: 600
                          }}
                        >
                          Conferido
                        </button>
                       {p.tipo === "titular" && (
                        <button
                          className="analise-btn"
                          onClick={() => aprovarProposta(p.id)}
                          disabled={!familiaTodaConferida(p)}
                          style={{
                            background: familiaTodaConferida(p) ? "#0288d1" : "#b0bec5",
                            color: "#fff",
                            fontWeight: 600,
                            cursor: familiaTodaConferida(p) ? "pointer" : "not-allowed"
                          }}
                          title={!familiaTodaConferida(p) ? "Todos os membros precisam estar conferidos para aprovar." : ""}
                        >
                          Aprovar
                        </button>
                        )}
                        {p.tipo === "titular" && (
                          <button
                            className="analise-btn-sec"
                            onClick={() => cancelarProposta(p.id)}
                            style={{
                              background: "#e53935",
                              color: "#fff",
                              fontWeight: 600
                            }}
                          >
                            Cancelar
                          </button>
                        )}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
      {/* MODAL DE ANÁLISE COMPLETA */}
      {modalPacienteId && (
        <AnaliseModalCompleta
          id={modalPacienteId}
          onClose={() => {
            setModalPacienteId(null);
            setTimeout(() => setReload(x => x + 1), 300);
          }}
          onEncaminharMedico={() => {
            setModalPacienteId(null);
            setTimeout(() => setReload(x => x + 1), 300);
          }}
          onReload={() => setReload(x => x + 1)} // << NOVO
        />
      )}

    </div>
  );
}
